export default {"src":"/_next/static/media/logo-text-light.513ce3e5.svg","height":36,"width":113,"blurWidth":0,"blurHeight":0};